/**
 * A barra que fica no alto de toda tela de dentro: quem é, até onde alcança, e sair.
 *
 * Ela some na impressão e no PDF. O papel já diz de quem é a folha no cabeçalho dele, e uma
 * barra azul atravessada no alto de um relatório que vai para o arquivo da tesouraria seria
 * só tinta gasta.
 */
import type { JSX } from 'react'
import { servidor, type Eu } from '../api'
import { irPara } from '../rotas'
import { NOME_DO_SISTEMA } from '../identidade'

export function BarraDeCima({
  eu,
  aoSair,
  voltarPara
}: {
  eu: Eu
  aoSair: () => void
  /** Quando existe, aparece o caminho de volta à esquerda. */
  voltarPara?: { endereco: string; texto: string }
}): JSX.Element {
  async function sair(): Promise<void> {
    // Sai do servidor primeiro, para a sessão morrer de verdade, e não só na tela.
    try {
      await servidor.sair()
    } finally {
      aoSair()
    }
  }

  return (
    <header className="barra-do-painel so-tela">
      {voltarPara ? (
        <button className="voltar" onClick={() => irPara(voltarPara.endereco)}>
          ◀ {voltarPara.texto}
        </button>
      ) : (
        <span className="marca">{NOME_DO_SISTEMA}</span>
      )}
      {/*
        Nome, cargo e alcance, nesta ordem.

        Pedido do pastor Edson, de 11/10/2026: a conta é da PESSOA, e a pessoa se reconhece na
        tela. O cargo fica no meio porque ele é o que ela É; o alcance, embaixo, é o que ela
        PODE, e os dois podem discordar sem que nada esteja errado (um tesoureiro do Campo com
        a grade cortada para uma congregação só é uma situação de verdade).

        **O cargo não decide nada.** Quem decide o alcance é a grade de permissões, lá no
        servidor. Esta linha é texto.

        Quem foi cadastrado antes de a coluna existir não tem cargo, e aí a barra volta a ter
        duas linhas, como sempre teve. Nada pisca e nada fica em branco.
      */}
      <span className="quem">
        {eu.nome_no_notebook ?? eu.nome}
        <br />
        {eu.cargo !== null && (
          <>
            <span className="cargo">{eu.cargo}</span>
            <br />
          </>
        )}
        {eu.ve_o_campo_inteiro ? 'todo o Campo' : 'sua congregação'}
      </span>
      <button onClick={() => void sair()}>Sair</button>
    </header>
  )
}
